<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12 ">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">Aadhaar Verification​</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">

                <div class="row justify-content-center">
                    <div class="col-11 text-center">

                        <form [formGroup]="kycForm" (ngSubmit)="onSubmit()" novalidate>
                            <div class="row justify-content-center">
                                <div class="col-11 p-3">
                                    <div class="row">

                                        <div class="col-12">
                                            <div class="form-group" style="text-align: left;">
                                                <label class="control-label"
                                                    style="text-align: left; padding-bottom: 1rem;">To move
                                                    forward, please share your
                                                    Aadhaar number
                                                    number</label>
                                                <input type="text" formControlName="aadhaarNumber" class="form-control"
                                                    maxlength="12" minlength="12"
                                                    placeholder="Enter 12 digit aadhaar number"
                                                    (keypress)="allowOnlyNumbers($event)">
                                                <div *ngIf="m.aadhaarNumber.touched && m.aadhaarNumber.invalid"
                                                    class="error">
                                                    <div *ngIf="m.aadhaarNumber.errors?.required">Please enter
                                                        aadhaar number</div>
                                                    <div *ngIf="m.aadhaarNumber.errors?.pattern">Aadhaar no
                                                        should be of 12 digits
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="form-group info-list" style="text-align: left;">
                                                <ul>
                                                    <li>You will be redirected to DigiLocker next to securely verify
                                                        your Aadhaar.</li>
                                                    <li>Your information is encrypted and used only for
                                                        verification.</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="row justify-content-center text-center buttonDiv">
                                            <div class="col-12">
                                                <button class="btn btn-warning" [disabled]="!m.aadhaarNumber.valid"
                                                    type="submit">Proceed to DigiLocker</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>